import { useIsFocused } from '@garnish/core';

import { useSharedMenuContent } from '@sg/shared-fe-features-menu';

import { useContentfulClient, useIsPreviewModeEnabled } from '@order/Contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const useMenuContent = () => {
  const isScreenFocused = useIsFocused();
  const contentfulClient = useContentfulClient();
  const isPreviewModeEnabled = useIsPreviewModeEnabled();

  const { mappedContent, isFetching } = useSharedMenuContent({
    contentfulClient,
    isPreviewModeEnabled,
    pause: !isScreenFocused,
  });

  return {
    mappedContent,
    isFetchingMenuContent: isFetching,
  };
};
